module.exports = __webpack_public_path__ + "img/bg-header.1baa2e26.png";